import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class BaggageAdminService extends BaseService<any> {
  constructor() {
    super(`baggages`);
  }

  // Сканирование: смена статуса по бирке. Body: { tagCode, status, stationID?, trainID?, note? }
  scan = (payload: any) => appAxios.post(`${this.pathWithOrg()}/scan`, payload);

  // QR бирки (data-url). Возвращает { tagCode, qr }
  getTag = (id: any) => appAxios.get(`${this.pathWithOrg()}/${id}/tag`);

  // Печатная PDF-бирка (blob). Тянем через axios, чтобы прошёл Bearer-токен.
  getTagPdf = (id: any) =>
    appAxios.get(`${this.pathWithOrg()}/${id}/tag.pdf`, { responseType: "blob" });
}

export default new BaggageAdminService();
